import { newProjectActions } from 'features/BillOfMaterials/store/projectReducer'
import { BomItemType } from 'model/Project/BoMItemRow'
import { useEffect } from 'react'
import { useAppDispatch } from 'store/configureStore'
import { AssemblyDetails } from './AssemblyDetails'
import { PartTypeDetails } from './PartTypeDetails'
import { BomItemDetailsProps } from './ProjectDetails/BomItemDetailsProps'
import { ProjectDetails } from './ProjectDetails/ProjectDetails'

export const BomItemDetail = (props: BomItemDetailsProps) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    requestIdleCallback(
      () => {
        dispatch(newProjectActions.setBomItemInSearch(props.bomItemPointer))
      },
      { timeout: 1000 },
    )
  }, [dispatch, props.bomItemPointer])


  switch (props.bomItemPointer.type) {
    case BomItemType.project:
      return <ProjectDetails {...props} />
    case BomItemType.assemblyInstance:
    case BomItemType.assemblyType:
      return <AssemblyDetails {...props} />
    case BomItemType.partType:
    case BomItemType.partInstance:
      return <PartTypeDetails {...props} />
    default:
      return null
  }
}
